import Question from "@/components/Question";
import { When } from "react-if";
import Advantage from "./Advantage";
import BigEnterprises from "./BigEnterprises";
import Cooperation from "./Cooperation";
import MediumEnterprises from "./MediumEnterprises";
import SubscriptionPackage from "./SubscriptionPackage";
import styles from "./index.module.less";
export default function Content(props) {
  const { config, isMobile } = props;

  return (
    <>
      {/* 大企业授权场景 */}

      <BigEnterprises config={config} isMobile={isMobile}></BigEnterprises>
      <MediumEnterprises
        config={config}
        isMobile={isMobile}
      ></MediumEnterprises>
      {/* 企业素材定制购买套餐 */}
      <SubscriptionPackage
        config={config}
        isMobile={isMobile}
      ></SubscriptionPackage>
      <Advantage config={config} isMobile={isMobile}></Advantage>
      {/* 合作企业标识 */}
      <When condition={config?.showCooperate}>
        <Cooperation config={config} isMobile={isMobile}></Cooperation>
      </When>

      {/* 常见问题 */}
      <div className={styles.questionConent}>
        <Question
          questionTitle={<div className={styles.headTitle}>常见问题</div>}
          question={config?.question}
          questionMoreLink={config?.more}
        ></Question>
      </div>
    </>
  );
}
